import { FunctionComponent } from 'react';
import classnames from 'classnames';

// components
import Anchor from '@Components/Utils/Anchor';

// context
import { useViewDetected } from '@Components/Utils/ViewDetected';

// styles
import styles from './DiseaseCard.module.scss';

export interface DiseaseItem {
    id: string;
    title: string;
    slug: string;
    [key: string]: any;
}

interface DiseaseCardProps {
    title?: string;
    className?: string;
    diseases?: Array<DiseaseItem>;
}

const DiseaseCard: FunctionComponent<DiseaseCardProps> = ({ title, diseases, className, children }) => {
    const { deviceType } = useViewDetected();

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            <div className={styles.title}>{title}</div>

            <div className={styles.diseases}>
                {diseases?.map((item, index) => (
                    <Anchor className={styles.disease_item} href={`/tra-cuu/benh/${item.slug || item.id}`} key={`disease-item-${item.id}-${index}`}>
                        {item.title}
                    </Anchor>
                ))}
            </div>

            {children}
        </div>
    );
};

DiseaseCard.defaultProps = {
    diseases: [],
    className: '',
    title: 'Danh sách kết quả',
};

export default DiseaseCard;
